export * from './hammer-gesture-config';
